import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import './Login.css';

const ForgotPassword = () => {
  const [mobile, setMobile] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^\d{10}$/.test(mobile)) {
      toast.error('Enter valid 10-digit mobile number');
      return;
    }

    try {
      setLoading(true);

      const res = await fetch(
        'https://playinbyd.com/api/api-forget-password-mpin',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            app_key: 'SgRTXsywVmWteEBLlYWecwgbDiHwlh',
            env_type: 'Prod',
            mobile
          })
        }
      );

      const data = await res.json();
      console.log('Forgot OTP:', data);

      if (data.success) {
        toast.success('OTP sent successfully');

        // ✅ PASS OTP TO VERIFY PAGE (DEV MODE)
        navigate('/verify-otp', {
          state: {
            mobile,
            devOtp: data.otp // 👈 IMPORTANT
          }
        });
      } else {
        toast.error(data.msg || 'Failed to send OTP');
      }
    } catch (err) {
      toast.error('Server error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Forgot Password</h2>
          <p className="input-hint">Enter registered mobile number</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label>Mobile Number *</label>
            <input
              type="tel"
              value={mobile}
              onChange={(e) =>
                setMobile(e.target.value.replace(/\D/g, '').slice(0, 10))
              }
              placeholder="10-digit mobile number"
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="login-btn"
            disabled={loading}
          >
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ForgotPassword;
